import { createSelector } from 'reselect';
import { IRootState } from 'src/redux/interface';

export const loadingSelector = createSelector(
    (state: IRootState) => state.loading,
    (loading) => loading,
);
